<template>
  <div class="content content--global">
    <div class="bg-img">
      <img src="../../assets/images/hero-global.jpg">
    </div>

    <MyHeader :breadcrumbItems="[

        {
          name: pageName.name,
          path: `/${$route.params.companySlug}/global-delivery-network`
        },
      ]"/>

    <header class="content-header">
      <h1>{{ pageName.name }}</h1>
    </header>

    <div class="container main-content">
      <div class="row boxes-row">
        <div class="col-lg-3" v-for="region in regions" :key="region.id">
          <GDNRegionBox :box="region" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '../../components/general/Header'
import GDNRegionBox from "@/components/GDN/GDNRegionBox";
import settings from "@/settings";

export default {
  name: "GlobalDeliveryNetwork",
  components: {GDNRegionBox, MyHeader},
  data () {
    return {
      showList: false,
    }
  },
  mounted() {
    window._paq.push(['setDocumentTitle', this.pageName.name]);
    window._paq.push(['trackPageView']);
  },
  computed: {
    regions() {
      return this.$store.getters.settingsCompanyBySettingTypeCode(settings.SETTING_TYPES.GDN_REGIONS)
    },
    pageName() {
      return this.$store.getters.menu().find((item) => {
        return item.routeName === 'GlobalDeliveryNetwork'
      })
    }
  }
}
</script>
